import React, { useState } from 'react';
import { toast } from 'react-hot-toast';
import api from '../../services/api';
import FotosTrabajo from '../servicio/FotosTrabajo';
import { subirFotosTrabajo } from '../../utils/subirFoto';

// Fotos del trabajo desde el historial (14-oct-2026): se suman o se sacan y se guardan al toque.
// Sirve para la foto que quedó en el celu y se sube más tarde. Salen en el PDF y las ve la empresa.
export default function FotosDelTrabajo({ servicio, onCambio }) {
    const [fotos, setFotos] = useState(servicio.fotosTrabajo || []);
    const [guardando, setGuardando] = useState(false);
    const cambiar = async (nuevas) => {
        const antes = fotos;
        setFotos(nuevas);
        setGuardando(true);
        try {
            const { fotos: subidas, fallaron } = await subirFotosTrabajo(nuevas, `trabajo_${servicio.id}`);
            if (fallaron) toast.error('Alguna foto no se pudo subir. Probá de nuevo.');
            const r = await api.patch(`/servicios/${servicio.id}/fotos`, { fotos: subidas });
            setFotos(r.data.fotosTrabajo || []);
            onCambio && onCambio(r.data.fotosTrabajo || []);
            toast.success('Fotos guardadas');
        } catch (e) {
            setFotos(antes);
            toast.error(e?.response?.data?.mensaje || 'No se pudieron guardar las fotos');
        } finally { setGuardando(false); }
    };
    return (
        <div className={`p-3.5 rounded-2xl bg-panel ${guardando ? 'opacity-60 pointer-events-none' : ''}`}>
            <FotosTrabajo fotos={fotos} onChange={cambiar} titulo={guardando ? 'Guardando fotos…' : 'Fotos del trabajo'} />
        </div>
    );
}
